import './modal.css';

export const CallGuideModal = ({
  title = DEFAULT_PROPS.title,
  subTitle = DEFAULT_PROPS.subTitle,
  btnText = DEFAULT_PROPS.btnText,
  telNumber,
  handleClose,
}) => {
  return (
    <div className='modal-backdrop'>
      <div className='call-guide-modal call-guide-modal--bottom'>
        <div className='modal-wrap'>
          <div className='title-wrap'>
            <h3 className='title'>{title}</h3>
            <p className='sub-text'>{subTitle}</p>
          </div>

          <div className='contents-wrap'>
            <div className='cont-info'>
              <div>
                <h4 className='title'>병원 콜센터 문의</h4>
                <span>{telNumber}</span>
              </div>
              <div>
                <a href={`tel:${telNumber}`} className='call-btn'>
                  <span>전화하기</span>
                </a>
              </div>
            </div>
          </div>

          <div className='modal-btn-wrap'>
            <button className='btn' onClick={handleClose}>
              <span>{btnText}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const DEFAULT_PROPS = {
  title: <>등록된 정보 변경을 원하시나요?</>,
  subTitle: (
    <>
      지금 보고계신 개인정보는 병원에 저장된 정보예요. 변경을 원하실 경우 병원 콜센터로 직접 문의해주세요
    </>
  ),
  btnText: '닫기',
};
